/**
 * Send certificates, doesn't matter if they've been created already or not
 *
 * @param appointment_id
 * @returns {boolean}
 */
function send_certificate_wizard(appointment_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/certificate/getCertificateSendWizard/' + appointment_id,
        onOpen: function (elm, popup) {
            const certificateScreen = elm.find('.scroll-screen:nth-child(1)');
            const contactsScreen = elm.find('.scroll-screen:nth-child(2)');
            const sendScreen = elm.find('.scroll-screen:nth-child(3)');

            mandatoryCheckboxes(elm, certificateScreen, contactsScreen);
            disableContactCheckboxesWithWrongEmailAddresses(contactsScreen);
            onlySendToStudentsThatHaveGenerationEnabled(contactsScreen);
            triggerMessageInput(contactsScreen, sendScreen);
            initiate_default_message_selector(elm);

            elm.find('form').ajaxFormSubmit(function (data, form) {
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(true);
            }.bind([elm, popup]), function (xhr, status, error) {
                console.log({error});
                $('body').doneLoading();
            }.bind([elm, popup]), function () {
                $('body').isLoading('dark');
            });
        }
    });
    return false;

    /**
     * Tell the user to select at least one item in the list in front of him
     *
     * @param elm
     * @param certificateScreen
     * @param contactsScreen
     */
    function mandatoryCheckboxes(elm, certificateScreen, contactsScreen) {
        elm.find('[type="button"].button').click(function() {
            let checkScreen;

            if (certificateScreen.hasClass('active')) {
                checkScreen = certificateScreen;
            } else if (contactsScreen.hasClass('active')) {
                checkScreen = contactsScreen;
            }

            if (checkScreen.find('[type="checkbox"]:checked:not([disabled])').length === 0) {
                let identifier;
                if (checkScreen === certificateScreen) {
                    identifier = 'certificaat';
                } else if (checkScreen === contactsScreen) {
                    identifier = 'cursist';
                }
                squde_flash('Vink minimaal één ' + identifier + ' aan.', 'alert');
            } else {
                ajax_popup_scroll_to_next_screen();
            }
            return false;
        });
    }

    /**
     * Disable checkboxes for students that have a wrong email-address
     *
     * @param contactsScreen
     */
    function disableContactCheckboxesWithWrongEmailAddresses(contactsScreen) {
        contactsScreen.find('table.students-table, table.supervisors-table').bind('onReload', function() {
            contactsScreen.find('input[type="email"]').unbind('keyup').keyup(function() {
                const isCorrectEmail = function(email) {
                    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                }($(this).val());
                const checkbox = $(this).parents('tr').find('[type="checkbox"]:not([name="generate_students\[\]"])');
                if (isCorrectEmail) {
                    checkbox.removeAttr('disabled');
                    checkbox[0].checked = true;
                } else {
                    checkbox.attr('disabled', true);
                    checkbox[0].checked = false;
                }
            }).trigger('keyup');
        });
    }

    function onlySendToStudentsThatHaveGenerationEnabled(contactsScreen) {
        contactsScreen.find('table.students-table, table.supervisors-table').bind('onReload', function() {
            contactsScreen.find('input[type="checkbox"]').unbind('change.onlySendToStudentsThatHaveGenerationEnabled').bind('change.onlySendToStudentsThatHaveGenerationEnabled', function() {
                const checkbox = $(this);
                const isGenerateCheckbox = checkbox.attr('name') === 'generate_students[]';
                if (isGenerateCheckbox) {
                    const emailCheckbox = checkbox.parents('tr').find('[type="checkbox"][name="send_students\[\]"]');
                    if (checkbox[0].checked) {
                        emailCheckbox.removeAttr('disabled');
                        emailCheckbox[0].checked = true;
                    } else {
                        emailCheckbox.attr('disabled', true);
                        emailCheckbox[0].checked = false;
                    }
                }
            });
        });
    }

    function triggerMessageInput(contactsScreen, sendScreen) {
        contactsScreen.find('table.students-table, table.supervisors-table').bind('onReload', function() {
            contactsScreen.find('input[type="checkbox"]').unbind('change.triggerMessageInput').bind('change.triggerMessageInput', function() {
                const numberOfStudents = contactsScreen.find('input[name="send_students\[\]"]:checked').length;
                const numberOfSupervisors = contactsScreen.find('input[name="supervisors\[\]"]:checked').length;

                sendScreen.find('.has-both').toggle(numberOfStudents > 0 && numberOfSupervisors > 0);
                sendScreen.find('.student-message-form').toggle(numberOfStudents > 0);
                sendScreen.find('.supervisor-message-form').toggle(numberOfSupervisors > 0);
            });
        });
    }
}

/**
 * Opens the wizard in order to create certificates
 *
 * @param appointment_id
 * @returns {boolean}
 */
function certificate_wizard(appointment_id) {
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/certificate/getCertificateWizard/' + appointment_id,
        onOpen: function (elm, popup) {

            if (elm.find('form.choose_students').find('[type=checkbox]').length == 0) {
                squde_flash("Er zijn geen cursisten geslaagd gemeld.", "alert");
                popup.close();
            }


            var layouts, students;
            elm.find('form').ajaxFormSubmit(function (data, form) {
                $('body').doneLoading();
                if (form.hasClass('choose_layout')) {
                    layouts = data;
                    ajax_popup_scroll_to_next_screen();
                }
                if (form.hasClass('choose_students')) {
                    students = data;
                    get_certificates(appointment_id, students, layouts);
                    popup.close();
                }
            }.bind([elm, popup]), function (xhr, status, error) {
                $('body').doneLoading();
            }.bind([elm, popup]), function () {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * Actually get the certificate pdfs
 *
 * @param id
 * @param students
 * @param layouts
 */
function get_certificates(id, students, layouts) {
    var qry_str = "";
    students.forEach(function (student_id) {
        qry_str = qry_str + (qry_str == "" ? "?" : "&") + "students[]=" + student_id;
    });
    layouts.forEach(function (layout_id) {
        qry_str = qry_str + (qry_str == "" ? "?" : "&") + "layouts[]=" + layout_id;
    });
    var url = "/certificate/getFromAppointment/" + id + qry_str;
    if (window.pressed('alt')) {
        url = url + '&stream=true';
        window['pressed_keys'] = [];
        window.open(url);
    } else {
        window.location.replace(url);
    }
}
